import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import CustomTableBody from "../../../../../utilis/component/CustomTableBody";
import { Fragment, useContext, useEffect, useState } from "react";
import { contextType, MedicalHistoryContext } from "../MedicalHistory";
import { useMutation } from "react-query";
import { deleteMedicalHistory, getMedicalHistory } from "../../../../services";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import MedicalHistoryForm from "./MedicalHistoryForm";
import { useParams } from "react-router-dom";
import usePopup from "../../../../../hooks/usePopup";
import LogComonent from "../../../layouts/LogComonent";
import { Close } from "@mui/icons-material";
import EmptyListAlert from "../../../layouts/EmptyListAlert";
// import HistoryComponent from "../../../../../EMR/components/layouts/HistoryComponent";

function MedicalHistoryTable() {
  const { encounterId } = useParams();
  const [show, setShow] = useState(false);
  const { showSnackbar } = usePopup();
  const [selected, setSelected] = useState(-1);
  const { tableData, setEdit, edit, setTableData, refetch, setRefetch } =
    useContext(MedicalHistoryContext) as contextType;
  const { mutate } = useMutation(getMedicalHistory, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        setTableData(result.response || []);
        setRefetch(false);
      }
    },
  });

  const { mutate: deleteMedicalhis, isLoading: deleteLoading } = useMutation(
    deleteMedicalHistory,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          setRefetch(true);
          setSelected(-1);
          showSnackbar({
            message: result.responseMessage,
            open: true,
            duration: 2000,
            variant: "success",
          });
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            duration: 2000,
            variant: "warning",
          });
        }
      },
      onError: () => {
        showSnackbar({
          message: "Something went wrong !",
          open: true,
          duration: 2000,
          variant: "warning",
        });
      },
    }
  );

  useEffect(() => {
    if (refetch) {
      mutate(encounterId as string);
    }
  }, [refetch]);

  const handleEdit = (data: any) => {
    console.log(data);
    setEdit({
      ...data,
    });
    setShow(false);
  };

  const handleDelete = (id: number, index: number) => {
    deleteMedicalhis(id.toString());
    setSelected(index);
  };

  const handleClose = () => {
    setEdit(null);
  };

  return (
    <Paper>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow
              sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
            >
              {heading.map((heading, index) => (
                <TableCell
                  sx={(theme) => ({ color: theme.palette.background.paper })}
                  align="left"
                  key={`heading${index}`}
                >
                  {heading}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <CustomTableBody
            alert={"No Medical History Found"}
            isData={true}
            totalSpan={{ row: 3, col: 6 }}
            dataLoading={false}
          >
            <TableRow>
              <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
              <EmptyListAlert alert="No medical history" isData={Boolean((tableData?.length || show))} children=  {!show && (
                  <div className="w-full flex justify-end items-center p-2 gap-3">
                    <Button
                      color="success"
                      endIcon={<AddCircleIcon />}
                      onClick={() => {
                        setShow(true);
                        setEdit(null);
                      }}
                    >
                      add
                    </Button>
                      <div>
                                           {/* <LogComonent  /> */}
                                           {/* <HistoryComponent logProps={{title:"Medical History", field:"medicalhistory"}} title="Medical History" tableprops={tableProps} /> */}
                                      </div>
                    <LogComonent
                      field="medicaldisease"
                      title="Medical history"
                    />
                  </div>
                )}/>
              
                <Collapse in={show} timeout="auto" unmountOnExit>
                  <Box>
                    <MedicalHistoryForm
                      close={() => {
                        setShow(false);
                      }}
                    />
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
            {tableData?.map((item, index: number) => (
              <Fragment key={index}>
                <TableRow key={index}>
                  <TableCell>{item.emrDisease.diseaseName}</TableCell>
                  <TableCell>{item.duration}</TableCell>
                  <TableCell>
  <Tooltip title={item.medication || ""} arrow placement="right">
    <span
      style={{
        display: "inline-block",
        maxWidth: 220,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        cursor: "pointer"
      }}
    >
      {item.medication}
    </span>
  </Tooltip>
</TableCell>
                  <TableCell>
                    <div className="flex gap-2">
                      {edit?.id == item?.id ? (
                        <IconButton onClick={handleClose} color="error">
                          <Close />
                        </IconButton>
                      ) : (
                        <IconButton
                          color="primary"
                          onClick={() => {
                            handleEdit(item);
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                      )}
                      {deleteLoading && selected == index ? (
                        <CircularProgress size={20} color="error" />
                      ) : (
                        <IconButton
                          color="error"
                          onClick={() => {
                            handleDelete(item.id as number, index);
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
                    <Collapse
                      in={Boolean(edit) && edit?.id == item?.id}
                      timeout="auto"
                      unmountOnExit
                    >
                      <MedicalHistoryForm
                        close={() => {
                          setEdit(null);
                        }}
                      />
                    </Collapse>
                  </TableCell>
                </TableRow>
              </Fragment>
            ))}
          </CustomTableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default MedicalHistoryTable;

const heading = [
  "Diseases Details",
  "Duration",
  "Medication Details",
  "OPTIONS",
];

// const tableProps =[
//  { heading: "Diseases Details", key: "emrDisease.diseaseName" },
//  { heading: "Duration", key: "duration" },
//  { heading: "Medication Details", key: "medication" },

// ]
